import { buildQuoteLineDraft } from '../quote/quoteRollup';
import { toRatePlanView } from './offerView';
// No offer at all came back for the selected row + dates.
const SOLD_OUT_REASON = 'No bookable offer for these dates — the rate may be sold out.';
// A matching offer exists but is restricted with no reason attached.
const RESTRICTED_REASON = 'These dates aren’t available for this rate. Try adjusting your stay.';
// The calendar keys a rate-plan row by (unitGroupId, ratePlanId), both mirroring
// the offer's ids (falling back to name), so the resolution must match the offer
// on the same pair — not the rate plan alone — to stage the exact row clicked.
const ratePlanKey = (offer) => offer.ratePlan?.id ?? offer.ratePlan?.name ?? 'rate-plan';
const unitGroupKey = (offer) => offer.unitGroup?.id ?? offer.unitGroup?.name ?? 'unknown';
const isBookable = (offer) => !offer.isRestricted && offer.availableUnits > 0;
// Prefers the Apaleo validation messages so the salesperson sees the concrete
// reason (e.g. minimum-length-of-stay violated); falls back to a generic note.
const restrictionReason = (offer) => {
    const messages = (offer.validationMessages ?? [])
        .map(message => message.message)
        .filter(Boolean);
    return messages.length > 0 ? messages.join(' · ') : RESTRICTED_REASON;
};
export const resolveSelectedOffer = (result, row, property) => {
    const matching = result.offers.filter(offer => ratePlanKey(offer) === row.ratePlanId &&
        unitGroupKey(offer) === row.unitGroupId);
    if (matching.length === 0) {
        return { status: 'unbookable', reason: SOLD_OUT_REASON };
    }
    const bookable = matching.find(isBookable);
    if (!bookable) {
        return { status: 'unbookable', reason: restrictionReason(matching[0]) };
    }
    const ratePlan = toRatePlanView(bookable);
    const roomTypeName = bookable.unitGroup?.name ?? 'Room';
    return {
        status: 'bookable',
        draft: buildQuoteLineDraft(ratePlan, roomTypeName, property)
    };
};
